import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { authActions } from "../actions/auth.actions";

function PrivateRoute({ children }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [directLog, setDirectLog] = useState(false);
  const location = useLocation();
  let auth = useSelector((state) => state.authentication.loggedIn);

  useEffect(() => {
    const path = location.pathname.split("/")[1];
    if (searchParams.get("token") && path === "") {
      dispatch(
        authActions.directLogin(searchParams.get("token"), navigate)
      ).then((res) => {
        if (res) {
          setDirectLog(true);
        }
      });
    } else {
      setDirectLog(false);
    }
  }, []);
  if (directLog) {
    return children;
  } else {
    return auth ? children : <Navigate to="/login" />;
  }
}

export { PrivateRoute };
